// extracted by mini-css-extract-plugin
module.exports = {"noResultsContainer":"NoSearchResults_noResultsContainer__1nydX","cardImage":"NoSearchResults_cardImage__3y2Bu","message":"NoSearchResults_message__38EOL"};